
(()=>{
 const registry=new Map();
 const clamp=(n,min,max)=>Math.min(max,Math.max(min,n));
 const ease=n=>n*n*(3-2*n);
 const mount=scope=>scope.querySelectorAll('[data-fabric-studio]').forEach(root=>{
  if(registry.has(root))return;
  const shell=root.querySelector('.ufs__shell'),panels=[...root.querySelectorAll('[data-studio-panel]')],choices=[...root.querySelectorAll('[data-studio-choice]')];
  if(panels.length!==4||choices.length!==4||!shell)return;
  const motionPreview=!!root.closest('[data-ura-motion-preview="v1"]');
  const events=new AbortController(),signal=events.signal,reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const probe=root.querySelector('[data-studio-viewport]');
  const touch=matchMedia('(max-width:760px),(max-width:1023px) and (pointer:coarse)');
  const set=(node,key,value)=>{if(node.style.getPropertyValue(key)!==value)node.style.setProperty(key,value);};
  let frame=0,active=-1,step=1,pinTop=0,enabled=false,lastWidth=0,lastHeight=0,rendered=null,renderTime=0,paddingTop=0;
  const draw=position=>{
   const p=clamp(position,0,3.45),base=Math.min(3,Math.floor(p)),hold=innerWidth<=760?.68:.64,mix=base===3?0:ease(clamp((p-base-hold)/(1-hold),0,1));
   const current=base+(mix>=.5?1:0);
   panels.forEach((panel,i)=>{
    const weight=i===base?1-mix:i===base+1?mix:0;
    set(panel,'--ufs-opacity',weight>0?'1':'0');
    if(motionPreview)set(panel,'--ufs-photo-opacity',weight.toFixed(4));
    const clip=motionPreview?'none':i===base&&mix>0?(innerWidth<=760?'inset(0 '+(mix*100).toFixed(3)+'% 0 0)':'inset(0 0 '+(mix*100).toFixed(3)+'%)'):i===base+1&&mix>0?(innerWidth<=760?'inset(0 0 0 '+((1-mix)*100).toFixed(3)+'%)':'inset('+((1-mix)*100).toFixed(3)+'% 0 0)'):'inset(0)';
    set(panel,'clip-path',clip);set(panel,'--ufs-mobile-clip',clip);
    if(!motionPreview){
     const phase=clamp(p-i,0,1);
     set(panel,'--ufs-art-drift',(6-phase*12).toFixed(2)+'px');
     set(panel,'--ufs-art-scale',String(1.015+phase*.025));
     set(panel,'--ufs-glint',(-140+phase*280).toFixed(2)+'%');
     set(panel,'--ufs-pulse',String(Math.sin(phase*Math.PI)*.7));
     set(panel,'--ufs-ring',String(.85+phase*.15));
     set(panel,'--ufs-shift',((i===base?-1:1)*(1-weight)*10).toFixed(2)+'px');
    }
    panel.toggleAttribute('data-rendered',weight>0);
    if(current!==active){panel.toggleAttribute('data-active',i===current);panel.inert=i!==current;panel.setAttribute('aria-hidden',String(i!==current));}
   });
   choices.forEach((choice,i)=>{
    if(current!==active)choice.setAttribute('aria-pressed',String(i===current));
    set(choice,'--ufs-progress',clamp(p-i,0,1).toFixed(4));
   });
   set(root,'--ufs-total-progress',clamp(p/3.45,0,1).toFixed(4));
   if(current!==active){active=current;root.dataset.current=panels[current].dataset.studioPanel;}
  };
  const update=()=>{
   frame=0;if(!enabled||document.hidden||!root.isConnected)return;
   const rect=root.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;
   const target=clamp((pinTop-rect.top-paddingTop)/step,0,3.45);if(rendered!==null&&Math.abs(target-rendered)<.0002)return;rendered=target;draw(target);
  };
  const queue=()=>{if(enabled&&!document.hidden&&!frame)frame=requestAnimationFrame(update);};
  const reset=()=>{
   enabled=false;rendered=null;root.removeAttribute('data-story');root.style.removeProperty('height');
   panels.forEach(panel=>{panel.inert=false;panel.removeAttribute('aria-hidden');panel.removeAttribute('data-active');panel.removeAttribute('data-rendered');panel.style.clipPath='';panel.style.removeProperty('--ufs-opacity');panel.style.removeProperty('--ufs-shift');});
   choices.forEach(choice=>choice.setAttribute('aria-pressed','false'));active=-1;
  };
  const measure=()=>{
   const header=document.querySelector('[data-ura-header]'),headerHeight=Math.ceil(header?.getBoundingClientRect().height||64);
   const viewport=Math.min(probe.getBoundingClientRect().height||innerHeight,innerHeight);
   const preview=document.getElementById('PBarNextFrame')?76:0;
   pinTop=innerWidth<=760?12:headerHeight+12;root.style.setProperty('--ufs-header',headerHeight+'px');
   root.style.setProperty('--ufs-pin-top',pinTop+'px');
   const available=viewport-pinTop-preview-(innerWidth<=760?112:12);
   if(reduced.matches){reset();return;}
   root.setAttribute('data-story','');root.style.setProperty('--ufs-photo-height','160px');
   const mobile=innerWidth<=760,stage=root.querySelector('[data-studio-stage]');
   const overhead=shell.getBoundingClientRect().height-stage.getBoundingClientRect().height;
   const copy=Math.max(...panels.map(p=>p.querySelector('.ufs__copy').getBoundingClientRect().height));
   const visualWidth=mobile?stage.clientWidth:parseFloat(getComputedStyle(panels[0]).gridTemplateColumns);
   const photo=Math.min(520,visualWidth/1.5,available-overhead-(mobile?copy:0)-2);
   if(photo<(mobile?140:160)||(!mobile&&copy>available-overhead)){reset();return;}
   root.style.setProperty('--ufs-photo-height',Math.floor(photo)+'px');
   const scene=shell.getBoundingClientRect().height;
   if(scene>available+2){reset();return;}
   step=innerWidth<=760?Math.max(260,Math.min(420,viewport*.49)):Math.max(225,Math.min(360,viewport*.36));
   const style=getComputedStyle(root),padding=(parseFloat(style.paddingTop)||0)+(parseFloat(style.paddingBottom)||0);
   root.style.height=Math.ceil(scene+step*3.45+padding)+'px';root.style.setProperty('--ufs-story-height',root.style.height);
   paddingTop=parseFloat(style.paddingTop)||0;root.dataset.scrollStep=String(step);enabled=true;rendered=null;update();
  };
  const jump=index=>{
   if(!enabled)return;
   const pad=parseFloat(getComputedStyle(root).paddingTop)||0;
   const start=root.getBoundingClientRect().top+scrollY+pad-pinTop;
   window.scrollTo({top:start+clamp(index,0,3)*step,behavior:'smooth'});
  };
  choices.forEach((choice,index)=>{
   choice.addEventListener('click',()=>jump(index),{signal});
   choice.addEventListener('keydown',event=>{
    const rtl=getComputedStyle(root).direction==='rtl';let next;
    if(event.key==='ArrowRight')next=index+(rtl?-1:1);
    else if(event.key==='ArrowLeft')next=index+(rtl?1:-1);
    else if(event.key==='Home')next=0;
    else if(event.key==='End')next=3;
    else return;
    event.preventDefault();next=(next+4)%4;choices[next].focus({preventScroll:true});jump(next);
   },{signal});
  });
  window.addEventListener('scroll',queue,{signal,passive:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;}else{rendered=null;queue();}},{signal});
  window.addEventListener('resize',()=>{
   const height=probe.getBoundingClientRect().height||innerHeight;
   if(lastWidth!==innerWidth||(matchMedia('(pointer:fine)').matches&&Math.abs(lastHeight-height)>80)){lastWidth=innerWidth;lastHeight=height;measure();}
  },{signal,passive:true});
  window.addEventListener('pageshow',measure,{signal});
  reduced.addEventListener('change',measure,{signal});
  const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))panels.forEach(p=>p.querySelectorAll('img').forEach(i=>i.loading='eager'));},{rootMargin:'300px'});
  observer.observe(root);root.dataset.ready='true';root.querySelector('[data-studio-index]').hidden=false;
  lastWidth=innerWidth;lastHeight=probe.getBoundingClientRect().height||innerHeight;measure();
  document.fonts?.ready.then(()=>{if(!signal.aborted)measure();});
  const header=document.querySelector('[data-ura-header]');
  const resizer=typeof ResizeObserver!=='undefined'?new ResizeObserver(measure):null;
  if(header)resizer?.observe(header);
  registry.set(root,()=>{events.abort();observer.disconnect();resizer?.disconnect();cancelAnimationFrame(frame);});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
 window.addEventListener('load',()=>mount(document),{once:true});
 window.addEventListener('pageshow',()=>mount(document));
 document.addEventListener('shopify:section:load',event=>mount(event.target));
 document.addEventListener('shopify:section:unload',event=>{for(const [root,cleanup] of registry)if(event.target.contains(root)){cleanup();registry.delete(root);}});
})();



